import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { useColorScheme } from '../contexts/ColorSchemeContext';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { getColorClasses } = useColorScheme();
  const colors = getColorClasses();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className={`fixed bottom-8 right-8 z-50 p-3 bg-gradient-to-r ${colors.primary} text-gray-900 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 animate-bounce-gentle`}
          aria-label="Scroll to top"
        >
          <FaArrowUp className="w-5 h-5" />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
